export const bindingDirectionList = [
  { value: 'ltr' },
  { value: 'rtl' },
]
